

/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import * as React from "react";
import Dialog from "@mui/material/Dialog";
import "./subscribeDeatilsPopup.scss";
import { Form, Formik } from "formik";
import instance from "../../utils/axiosInstance";
import { ErrorCodes } from "../../constants/messageCodes";
import { TextBox } from "../allInputsFields/textBox/textBox";
import { Box, Button, CircularProgress, DialogActions, FormControlLabel, IconButton, Radio, RadioGroup } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ApproveSubscription, GetSubscriptionRequest, RejectSubscription } from "../../constants/api-urlConstants";
import { MessageText } from "../../constants/messageText";
import { ConfirmationBox } from "../ConfirmationBox/ConfirmationBox";
import { TimerValusSet } from "../../context/TimerContext";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

interface Props {
  openSubscribePopup: any;
  selectedUserID: any;
  closeSubscribePopup: (value: any) => void;
  errorMessageShow: (message: any) => void;
}

export default function SubscribeUserDetails(props: Props) {

  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [showRejectConfirmation, setShowRejectConfirmation] = React.useState(false);
  const { setUserHeartBeat, timeExit } = React.useContext(TimerValusSet);
  const [expiryDate, setExpiryDate] = React.useState<any>();
  const [msgConfig, setMsgConfig] = React.useState({
    popupTitle: '',
    popupDesc: ''
  });
  const [open, setOpen] = React.useState(props.openSubscribePopup);
  const [userData, setUserData] = React.useState<any>({});
  const [userDetailsLoading, setUserDetailsLoading] = React.useState(false);
  const [userApproveLoading, setUserApproveLoading] = React.useState(false);
  const [userRejectLoading, setUserRejectLoading] = React.useState(false);
  const [authMethod, setAuthMethod] = React.useState<{
    isMfaEnabled: boolean,
    isTwofaEnabled: boolean,
  }>({
    isMfaEnabled: false,
    isTwofaEnabled: true
  });
  const [openDatePopup, setOpenDatePopup] = React.useState(false);

  const initial_state = {
    accountManagerEmail: userData?.accountManagerEmail,
    accountManagerName: userData?.accountManagerName,
    authorizerEmail: userData?.authorizerEmail == null ? "" : userData?.authorizerEmail,
    authorizerName: userData?.authorizerName == null ? "" : userData?.authorizerName,
    authorizerPhone: userData?.authorizerPhone,
    companyName: userData?.companyName,
    email: userData?.email,
    name: userData?.name,
    phone: userData?.phone,
    role: userData?.role?.value,
    subscriptionRequested: userData?.subscriptionRequested,
    contract: true,
    financialModel: false,
    subscriptionStatus: userData?.subscriptionStatus,
    isMfaEnabled: false,
    isTwofaEnabled: true,
    expirationDate: null,
  };

  const handleClose = () => {
    setOpen(false);
    props.closeSubscribePopup(false);
  };

  const getSubscriptionRequest = () => {
    setUserDetailsLoading(true);
    const USER_API_BASE_URL = `${GetSubscriptionRequest}/${props.selectedUserID}`;
    instance
      .get(USER_API_BASE_URL)
      .then((response) => {
        setUserHeartBeat(timeExit());
        if (response.data.success) {
          setUserDetailsLoading(false);
          const res = response.data.data;
          setUserData(res);
        }
        if (response.data.message_code === ErrorCodes.INTERNAL_SERVER_ERROR) {
          setUserDetailsLoading(false);
          props.errorMessageShow({
            type: 'error',
            message: MessageText.INTERNAL_SERVER_ERROR,
            snackFlag: true
          })
        }
      })
      .catch((error) => {
        setUserDetailsLoading(false);
      });
  };

  const approveSubscriptionUser = (userId: number) => {
    setUserApproveLoading(true);
    const payload = {
      id: userId,
      isMfaEnabled: authMethod.isMfaEnabled,
      isTwofaEnabled: authMethod.isTwofaEnabled,
      expirationDate: expiryDate ? dayjs(expiryDate).format("YYYY-MM-DD") : ""
    }
    const SUBSCRIBE_USER_API_BASE_URL = `${ApproveSubscription}`;
    instance
      .post(SUBSCRIBE_USER_API_BASE_URL, payload)
      .then((response) => {
        setUserHeartBeat(timeExit());
        if (response.data.success) {
          setUserApproveLoading(false);
          setOpen(false);
          props.errorMessageShow({
            type: 'success',
            message: MessageText.APPROVE_USER_SUCCESS,
            snackFlag: true
          })
          props.closeSubscribePopup(false);
        }
        else if (response.data.message_code === ErrorCodes.INTERNAL_SERVER_ERROR) {
          setUserApproveLoading(false);
          showErrorMessage('internal');
        } else {
          setUserApproveLoading(false);
          showErrorMessage('went_wrong');
        }
      })
      .catch((error) => {
        setUserApproveLoading(false);
      });
  };

  const showErrorMessage = (type: string) => {
    props.errorMessageShow({
      type: 'error',
      message: type === 'internal' ? MessageText.INTERNAL_SERVER_ERROR : MessageText.WENT_WRONG,
      snackFlag: true
    });
  }

  const rejectSubscriptionUser = (userId: number) => {
    setUserRejectLoading(true);
    const payload = {
      id: userId,
    }
    const REJECT_SUBSCRIPTION_USER_API_BASE_URL = `${RejectSubscription}`;
    instance
      .post(REJECT_SUBSCRIPTION_USER_API_BASE_URL, payload)
      .then((response) => {
        setUserHeartBeat(timeExit());
        if (response.data.success) {
          setUserRejectLoading(false);
          setOpen(false);
          props.errorMessageShow({
            type: 'success',
            message: MessageText.REJECT_USER_SUCCESS,
            snackFlag: true
          })
          props.closeSubscribePopup(false);
        } else if (response.data.message_code === ErrorCodes.INTERNAL_SERVER_ERROR) {
          setUserRejectLoading(false);
          showErrorMessage('internal');
        } else {
          setUserRejectLoading(false);
          showErrorMessage('went_wrong');
        }
      })
      .catch((error) => {
        setUserRejectLoading(false);
      });
  }

  const onConfirmAction = (value: any) => {
    setShowConfirmation(false);
    if (value) {
      approveSubscriptionUser(props.selectedUserID);
    }
  };

  const onConfirmRejectAction = (value: any) => {
    setShowRejectConfirmation(false);
    if (value) {
      rejectSubscriptionUser(props.selectedUserID);
    }
  };

  React.useEffect(() => {
    getSubscriptionRequest();
    return () => {
      setAuthMethod({
        isMfaEnabled: false,
        isTwofaEnabled: true
      });
    }
  }, []);

  return (
    <div className="subscribeWrapper">
      <Dialog
        open={open}
        fullWidth={true}
      >
        <div className="subscribeWrapper scrollbarColor">
          <div className="subscribeTitle">
            Subscription Request
            <IconButton className="closeButton" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {userDetailsLoading ? (
            <div className="userDetailLoading">
              <CircularProgress />
            </div>
          ) : (
            <>
              <Formik
                enableReinitialize={true}
                initialValues={initial_state}
                onSubmit={(value: any) => {
                }}
              >
                {(formik) => (
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="subscribeContent">
                      <div className="contentText">
                        User details
                      </div>
                      <div className="formTextFields">
                        <TextBox
                          formikRef={formik}
                          textBoxName={"companyName"}
                          textBoxLabel={"Company Name *"}
                          textBoxDisable={true}
                          inputPropsObj={{ spellCheck: false }}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("companyName", data);
                          }}
                        />
                        <TextBox
                          formikRef={formik}
                          textBoxName={"name"}
                          textBoxDisable={true}
                          textBoxLabel={"Individual Name *"}
                          inputPropsObj={{
                            maxLength: 25,
                            spellCheck: false,
                          }}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("name", data);
                          }}
                        />
                        <TextBox
                          formikRef={formik}
                          textBoxName={"email"}
                          textBoxDisable={true}
                          inputPropsObj={{ spellCheck: false }}
                          textBoxLabel={"Email *"}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("email", data);
                          }}
                        />
                        <div className="phoneNumberWrapper ">
                          <TextBox
                            formikRef={formik}
                            textBoxName={"phone"}
                            textBoxDisable={true}
                            inputPropsObj={{ spellCheck: false }}
                            textBoxLabel={"Phone# *"}
                            margin={"dense"}
                            onChangeCallBack={(data: any) => {
                              formik.setFieldValue("phone", data);
                            }}
                          />
                        </div>
                        <TextBox
                          formikRef={formik}
                          textBoxName={"role"}
                          textBoxDisable={true}
                          inputPropsObj={{ spellCheck: false }}
                          textBoxLabel={"Job Role*"}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("email", data);
                          }}
                        />
                      </div>
                      <div className="contentText">
                        <span className="topTextBold">
                          Account manager details
                        </span>
                      </div>
                      <div className="formTextFields">
                        <TextBox
                          formikRef={formik}
                          textBoxName={"accountManagerName"}
                          textBoxLabel={"Name"}
                          inputPropsObj={{
                            maxLength: 25,
                            spellCheck: false,
                          }}
                          textBoxDisable={formik.values.subscriptionRequested}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("accountManagerName", data);
                          }}
                        />

                        <TextBox
                          formikRef={formik}
                          textBoxName={"accountManagerEmail"}
                          inputPropsObj={{ spellCheck: false }}
                          textBoxLabel={"Email"}
                          textBoxDisable={formik.values.subscriptionRequested}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("accountManagerEmail", data);
                          }}
                        />
                      </div>
                      <div className="contentText">
                        Authorizer details
                      </div>
                      <div className="formTextFields">
                        <TextBox
                          formikRef={formik}
                          textBoxName={"authorizerName"}
                          textBoxLabel={"Name *"}
                          textBoxDisable={formik.values.subscriptionRequested}
                          inputPropsObj={{
                            maxLength: 25,
                            spellCheck: false,
                          }}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("authorizerName", data);
                          }}
                        />
                        <TextBox
                          formikRef={formik}
                          textBoxName={"authorizerEmail"}
                          inputPropsObj={{ spellCheck: false }}
                          textBoxLabel={"Email *"}
                          textBoxDisable={formik.values.subscriptionRequested}
                          margin={"dense"}
                          onChangeCallBack={(data: any) => {
                            formik.setFieldValue("authorizerEmail", data);
                          }}
                        />
                        <div className="phoneNumberWrapper ">
                          <TextBox
                            formikRef={formik}
                            textBoxName={"authorizerPhone"}
                            inputPropsObj={{ spellCheck: false }}
                            textBoxLabel={"Phone#"}
                            textBoxDisable={formik.values.subscriptionRequested}
                            margin={"dense"}
                            onChangeCallBack={(data: any) => {
                              formik.setFieldValue("authorizerPhone", data);
                            }}
                          />
                        </div>
                      </div>

                      <Box sx={{mt: 0.5, mb: 2}}>
                        <div className="formTextFields">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Expiry Date"
                              value={formik.values.expirationDate}
                              onChange={(value) => setExpiryDate(value)}
                              minDate={dayjs()}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  fullWidth: true,
                                  name: 'expirationDate',
                                  id: 'expirationDate',
                                },
                                field: {
                                  onClick: () => setOpenDatePopup(true),
                                }
                              }}
                              open={openDatePopup}
                              onOpen={() => setOpenDatePopup(true)}
                              onClose={() => setOpenDatePopup(false)}
                            />
                          </LocalizationProvider>
                        </div>
                      </Box>

                      <div className="contentText">
                        MFA / 2FA
                      </div>
                      <div className="formTextFields">
                        <RadioGroup
                          row
                          sx={{ flexWrap: 'nowrap' }}
                          aria-labelledby="radio-buttons-mfa-2fa"
                          name="radio-buttons-mfa-2fa"
                          value={formik.values.isMfaEnabled ? 'MFA' : formik.values.isTwofaEnabled ? '2FA' : ''}
                          onChange={e => {
                            const value = (e.target.value);
                            const is2fa = value === '2FA';
                            const isMfa = value === 'MFA';
                            formik.setFieldValue('isTwofaEnabled', is2fa);
                            setTimeout(() => {
                              formik.setFieldValue('isMfaEnabled', isMfa);
                            }, 100);
                          }}
                        >
                          <FormControlLabel value="MFA" control={<Radio />} label="MFA" />
                          <FormControlLabel value="2FA" control={<Radio />} label="2FA" />
                        </RadioGroup>
                      </div>
                    </div>
                    <DialogActions className="actionDialog">
                      <Button
                        color="error"
                        className="approveButton"
                        variant="contained"
                        disabled={formik?.values?.subscriptionStatus === "REJECTED"}
                        onClick={() => {
                          setShowRejectConfirmation(true);
                          setMsgConfig({
                            popupTitle: MessageText.REJECT_USER,
                            popupDesc: MessageText.REJECT_USER_TEXT
                          });
                        }}
                      >
                        {!userRejectLoading ? "Reject"
                          : (
                            <div className="submitFormLoading">
                              <CircularProgress color="inherit" size={20} />
                            </div>
                          )}
                      </Button>
                      <Button
                        color="success"
                        className="approveButton"
                        variant="contained"
                        onClick={() => {
                          setShowConfirmation(true);
                          setMsgConfig({
                            popupTitle: MessageText.APPROVE_USER,
                            popupDesc: MessageText.APPROVE_USER_TEXT
                          });
                          setAuthMethod({
                            isMfaEnabled: formik.values.isMfaEnabled,
                            isTwofaEnabled: formik.values.isTwofaEnabled
                          })
                        }}
                      >
                        {!userApproveLoading ? "Approve"
                          : (
                            <div className="submitFormLoading">
                              <CircularProgress color="inherit" size={20} />
                            </div>
                          )}
                      </Button>
                    </DialogActions>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </div>
      </Dialog>
      {showConfirmation &&
        <ConfirmationBox openConfirmation={showConfirmation} closeConfirmation={onConfirmAction} msgConfig={msgConfig} />
      }
      {showRejectConfirmation &&
        <ConfirmationBox openConfirmation={showRejectConfirmation} closeConfirmation={onConfirmRejectAction} msgConfig={msgConfig} />
      }
    </div>
  );
}
